import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";
/**
 * Lo stato vuoto: cosa manca, in una riga, e l'unica azione che lo riempie.
 * Serve identico per una lista vuota e per una sezione non ancora attiva.
 *
 * - `icon`: un'icona lucide che viene dal dominio (Users, FileText, Receipt…)
 * - `action` / `secondary`: bottoni già pronti (Button)
 * - `placeholders`: compatibilità con le pagine esistenti; diventa una riga "In arrivo: …"
 */
export default function EmptyStateSection({
  eyebrow,
  title,
  description,
  icon: Icon = Inbox,
  action,
  secondary,
  placeholders = [],
  testId,
  className,
}) {
  return (
    <section
      data-testid={testId}
      className={cn(
        "rounded-xl border border-dashed bg-card px-card py-section text-center",
        className,
      )}
    >
      <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-lg bg-muted text-muted-foreground">
        <Icon className="h-5 w-5" aria-hidden />
      </div>
      {eyebrow ? (
        <p className="mt-group text-eyebrow uppercase text-muted-foreground">{eyebrow}</p>
      ) : null}
      <h2 className={cn("text-lg font-semibold text-foreground", eyebrow ? "mt-micro" : "mt-group")}>
        {title}
      </h2>
      {description ? (
        <p className="mx-auto mt-inside max-w-md text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action || secondary ? (
        <div className="mt-card flex flex-wrap items-center justify-center gap-inside">
          {action}
          {secondary}
        </div>
      ) : null}
      {placeholders.length ? (
        <p className="mt-card text-xs text-muted-foreground">
          In arrivo: {placeholders.map((p) => p.title).join(" · ")}
        </p>
      ) : null}
    </section>
  );
}
